<div class="flex items-center justify-between py-1">
  <slot></slot>
</div>
